import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AppContainer from 'components/AppContainer';
import SearchTypes from './SearchTypes';
import FilterContext from './FilterContext';
import MobileTopicsDialog from './MobileTopicsDialog';

const useStyles = makeStyles(theme => ({
  root: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: props => props.bg || 'rgba(1, 97, 155, 0.9)',
    alignItems: 'center',
    filter: props => (props.bg ? 'brightness(0.96)' : 'brightness(1)'),
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  mobileTopics: {
    marginBottom: 10,
  },
  mobileButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  button: {
    color: theme.palette.primary.main,
    boxShadow: 'none',
    width: 163,
    height: 54,
    backgroundColor: '#fff !important',
    [theme.breakpoints.down('900')]: {
      width: 100,
    },
    [theme.breakpoints.down('600')]: {
      width: 163,
    },
    borderRadius: 27,
    ...theme.typography.button,
  },
}));

function MobileScroll() {
  const {
    selectedTopic,
    changeFilter,
    mediaTypes,
    selectedMediaType,
    go,
    themes,
    searchTopic,
    selectedTopicSlug,
    isSearching,
    filteredTopicsList,
    bg,
  } = useContext(FilterContext);
  const classes = useStyles({ bg });
  return (
    <Grid container direction="row" className={classes.root}>
      <AppContainer noPadding>
        <Grid item xs={12} className={classes.mobileTopics}>
          <MobileTopicsDialog
            themes={themes}
            changeFilter={changeFilter}
            selectedTopic={selectedTopic}
            searchTopic={searchTopic}
            isSearching={isSearching}
            filteredTopicsList={filteredTopicsList}
          />
        </Grid>
        <Grid item xs={12}>
          <SearchTypes
            data={mediaTypes}
            value={selectedMediaType}
            changeHandler={changeFilter}
          />
        </Grid>
        <Grid item xs={12} className={classes.mobileButton}>
          <Button
            variant="contained"
            className={classes.button}
            onClick={go}
            disabled={!selectedTopicSlug || !selectedMediaType}
          >
            GO
          </Button>
        </Grid>
      </AppContainer>
    </Grid>
  );
}

export default MobileScroll;
